// Page paths
export const SRPPath = '/Hotel/Search'
export const HPPath = '/'
export const PPPath = '/checkout'
export const CPPath = '/confirmation'
export const APPath = '/Hotel/:hotelSlug/:locale?'
export const BMPath = '/bookings/:bookingId'

// URL params
export const SIMULATE_PARAM = 'simulate'

//APP ENV
export const APP_ENV_PRODUCTION_LIST = ['prd', 'production']
